// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__HOx8o","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__20qRD"};